import React, { useState } from 'react';
import './Contact.css';
import contactImg from '../assets/contact.png';

function Contact() {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <section id="contact" className="contact-section">
            <h2 className="section-title">Get In Touch</h2>

            <div className="contact-layout">
                {/* Left: Image */}
                <div className="contact-img-wrap">
                    <img src={contactImg} alt="Contact" className="contact-img" />
                </div>

                {/* Right: Content */}
                <div className="contact-content">
                    <p className="contact-text">
                        I am currently open for internship opportunities and collaborative projects. Whether you have a question or just want to say hi, I'll try my best to get back to you!
                    </p>

                    <div style={{ position: "relative", display: "inline-block" }}>
                        <button className="btn-primary" onClick={() => setShowPopup(!showPopup)}>
                            Say Hello
                        </button>

                        {showPopup && (
                            <>
                                <div className="contact-popup-backdrop" onClick={() => setShowPopup(false)} />
                                <div className="contact-popup">
                                    <button className="contact-popup-close" onClick={() => setShowPopup(false)}>✕</button>
                                    <ul className="contact-popup-list">
                                        <li><span className="contact-popup-icon">📞</span><span>+63 945 852 7119</span></li>
                                        <li><span className="contact-popup-icon">✉️</span><span>s2023101870@firstasia.edu.ph</span></li>
                                        <li><span className="contact-popup-icon">📍</span><span>538, Sitio Sampalocan Malbanan, Balete, Batangas</span></li>
                                        <li><span className="contact-popup-icon">🏫</span><span>First Asia Institute of Technology and Humanities</span></li>
                                    </ul>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="contact-links">
                        <a href="https://github.com" target="_blank" rel="noreferrer">GitHub</a>
                        <a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a>
                        <a href="mailto:s2023101870@firstasia.edu.ph">Email</a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
